export enum RestrictionTypes {
  AttachTradingAccount = 10,
  AddTradingAccount = 11,
  Deposit = 12,
  Withdraw = 13,
  TransferFrom = 14,
  TransferTo = 15,
}
